import { render, staticRenderFns } from "./BuyYoSimulasi.vue?vue&type=template&id=2c2f669a&scoped=true&"
import script from "./BuyYoSimulasi.vue?vue&type=script&lang=js&"
export * from "./BuyYoSimulasi.vue?vue&type=script&lang=js&"
import style0 from "./BuyYoSimulasi.vue?vue&type=style&index=0&id=2c2f669a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f669a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VTextField})
